import { Autocomplete, Skeleton, TextField } from '@mui/material';
import { isEmptyString, withDefault } from '@vy/utils';
import { useState } from 'react';
import { VyDialog } from '../../../../../../components/new-design/feedback/VyDialog';
import { useShareInvoiceToSlack, useSlackGetUsers } from '../../../../../../hooks/requests/use-slack';
import { runMutation } from '../../../../../../utils/vy-mutation';

type ShareInvoiceToSlackDialogProps = {
  open: boolean;
  onClose: () => void;
  invoiceId: string;
};

export const ShareInvoiceToSlackDialog: React.FC<ShareInvoiceToSlackDialogProps> = ({
  open,
  onClose,
  invoiceId,
}) => {
  // Only fetch when dialog is open, don't use suspense to avoid blocking
  const { data, isLoading } = useSlackGetUsers({
    suspense: false,
    enabled: open, // Only fetch when dialog is actually open
  });
  const [selectedUserId, setSelectedUserId] = useState<string>('');

  const shareInvoiceToSlackMutation = useShareInvoiceToSlack();

  const handleShareInvoiceToSlack = async () => {
    await runMutation(
      shareInvoiceToSlackMutation,
      { userId: selectedUserId, invoice: invoiceId },
      {
        pending: 'Sharing invoice to slack...',
        success: 'Invoice shared to slack',
        error: 'Failed to share invoice to slack',
      },
    );
  };

  const onSubmit = async () => {
    await handleShareInvoiceToSlack();
    onClose();
    setSelectedUserId('');
  };

  return (
    <VyDialog
      open={open}
      onClose={onClose}
      label="Share Invoice with the team"
      cancelButtonText="Cancel"
      ctaDisabled={isEmptyString(selectedUserId) || isLoading}
      ctaText="Share"
      onSubmit={onSubmit}
    >
      {isLoading ? (
        <Skeleton height={56} animation="wave" />
      ) : (
        <Autocomplete
          options={withDefault(data?.users, [])}
          getOptionLabel={(user) => user.realName}
          onChange={(_event, user) => setSelectedUserId(user?.id ?? '')}
          renderInput={(params) => (
            <TextField {...params} label="slack member" size="medium" sx={{ padding: '15px' }} />
          )}
        />
      )}
    </VyDialog>
  );
};
